/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSuggestedTimesWarning_org = {
    readonly workingGroups: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly rooms: ReadonlyArray<{
                    readonly id: string;
                    readonly roomId: string;
                    readonly orgId: string;
                    readonly name: string;
                    readonly estimatedCapacity: number | null;
                } | null> | null;
            } | null;
        } | null> | null;
    };
    readonly " $refType": "EventSuggestedTimesWarning_org";
};
export type EventSuggestedTimesWarning_org$data = EventSuggestedTimesWarning_org;
export type EventSuggestedTimesWarning_org$key = {
    readonly " $data"?: EventSuggestedTimesWarning_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSuggestedTimesWarning_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSuggestedTimesWarning_org",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                }
            ],
            "concreteType": "WorkingGroupConnection",
            "kind": "LinkedField",
            "name": "workingGroups",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkingGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Room",
                                    "kind": "LinkedField",
                                    "name": "rooms",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "roomId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "orgId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "estimatedCapacity",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": "workingGroups(first:1000000)"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '62ba3c4646aa209523969e1e7ad3a9b6';
export default node;
